import { module } from 'modujs';
import { html } from '../utils/environment';

export default class extends module {
    constructor(m) {
        super(m);

        this.events = {
            click: 'toggle'
        }
    }

    init() {
        this.isAvailable = true;
    }

    toggle() {
        if (!this.isAvailable) return;

        this.isAvailable = false;
        html.classList.remove('has-nav-open-callback');
        html.classList.toggle('has-nav-open');

        gsap.delayedCall(0.8, () => {
            if (html.classList.contains('has-nav-open')) {
                html.classList.add('has-nav-open-callback');
            } else {
                html.classList.remove('has-nav-open-callback');
            }

            this.isAvailable = true;
        });
    }
}
